export default "__VITE_PUBLIC_ASSET__5428cd35__"